import { INVITATION_PRICING_PLANS_ENUM } from "../../invitations/dto/invitations.dto";

export interface OrderItems {
	name: string;
	amount: number;
	description: string;
	quantity: number;
}

export enum INVITATION_ORDER_STATUSES_ENUM {
	PENDING = 1,
	COMPLETED = 2,
	FAILED = 3,
	CANCELLED = 4
}

export interface Order {
	user_id: string;
	invitation_id: string;
	planId: INVITATION_PRICING_PLANS_ENUM;
	amount: number;
	currency: string;
	orderId: string;
	status: INVITATION_ORDER_STATUSES_ENUM;
	client_secret: string;
	items: OrderItems[];
	createdAt: string;
}
